import { api } from "./index"; // Import the base API

export const postsEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    addDestination: builder.mutation({
      query: (newDestination) => {
        // Log the newBrief object to the console

        // Your existing code for the API request
        return {
          url: "destinations",
          method: "POST",
          body: JSON.stringify(newDestination),
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
      invalidatesTags: [
        { type: "AdminDestinationList", id: "AdminDestinationList" },
      ],
    }),

    addDestinationImage: builder.mutation({
      query: (newDestination) => {
        const formData = new FormData();

        newDestination.images.forEach((file, index) => {
          formData.append(`images[${index}].Image`, file);
          formData.append(`images[${index}].Caption`, "");
          formData.append(`images[${index}].IsDisplayImage`, false);
        });

        return {
          url: `destinations/${newDestination.destinationId}/images`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [
        { type: "AdminDestinationList", id: "AdminDestinationList" },
      ],
    }),

    addAdventure: builder.mutation({
      query: (newAdventure) => {
        // Log the newBrief object to the console

        // Your existing code for the API request
        return {
          url: "adventures",
          method: "POST",
          body: JSON.stringify(newAdventure),
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
      invalidatesTags: [
        { type: "AdminAdventureList", id: "AdminAdventureList" },
      ],
    }),

    addProgramme: builder.mutation({
      query: (newProgramme) => {
        // Log the newBrief object to the console

        // Your existing code for the API request
        return {
          url: "programmes",
          method: "POST",
          body: JSON.stringify(newProgramme),
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
      invalidatesTags: [
        { type: "AdminProgrammeList", id: "AdminProgrammeList" },
      ],
    }),

    addProgrammeAdventures: builder.mutation({
      query: ({ programmeId, adventureIds }) => {
        return {
          url: `programmes/${programmeId}/adventures`,
          method: "POST",
          body: JSON.stringify({ adventureIds }),
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
      invalidatesTags: [
        { type: "AdminProgrammeList", id: "AdminProgrammeList" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddDestinationMutation,
  useAddAdventureMutation,
  useAddProgrammeMutation,
  useAddDestinationImageMutation,
  useAddProgrammeAdventuresMutation,
  // ... export other hooks ...
} = postsEndpoints;
